document.addEventListener('DOMContentLoaded', function() {
  // Initialize mobile accordion on product pages.
  // NOTE: uses data-pdp-accordion* (not data-accordion*) deliberately — the
  // theme's own bundled JS (layout.theme.js) also binds [data-accordion] with
  // its own click handler and height logic, and having both bound to the same
  // elements caused double-toggling / stale-height bugs. Renaming these
  // attributes on the PDP tabs/accordion snippet keeps this handler as the
  // sole owner of PDP accordion behavior.
  var accordions = document.querySelectorAll('[data-pdp-accordion]');
  if (!accordions.length) return;

  accordions.forEach(function(acc) {
    var btn = acc.querySelector('[data-pdp-accordion-btn]');
    var content = acc.querySelector('[data-pdp-accordion-data]');
    if (!btn || !content) return;

    btn.addEventListener('click', function() {
      var isOpen = btn.classList.contains('open');

      // Close all other accordions
      accordions.forEach(function(otherAcc) {
        var otherBtn = otherAcc.querySelector('[data-pdp-accordion-btn]');
        var otherContent = otherAcc.querySelector('[data-pdp-accordion-data]');
        if (otherBtn && otherContent && otherBtn !== btn) {
          otherBtn.classList.remove('open');
          otherContent.classList.remove('pdp-accordion-open');
        }
      });

      // Toggle this accordion via a CSS class with a generous max-height cap
      // (see product-v2.css .pdp-accordion-open) instead of measuring
      // scrollHeight at click time — that measurement can be stale/wrong if
      // content was added dynamically (e.g. the pdp-tab-lead paragraph),
      // silently clipping newly-added content.
      if (!isOpen) {
        btn.classList.add('open');
        content.classList.add('pdp-accordion-open');
      } else {
        btn.classList.remove('open');
        content.classList.remove('pdp-accordion-open');
      }
    });
  });

  // Auto-open first accordion item on mobile
  var firstAcc = document.querySelector('.product_accordion [data-pdp-accordion]:first-child');
  if (firstAcc && window.innerWidth <= 991) {
    var firstBtn = firstAcc.querySelector('[data-pdp-accordion-btn]');
    var firstContent = firstAcc.querySelector('[data-pdp-accordion-data]');
    if (firstBtn && firstContent) {
      firstBtn.classList.add('open');
      firstContent.classList.add('pdp-accordion-open');
    }
  }
});
